import { useEffect } from "react";

export function MoveToTopOnMount() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, []);

  return null;
}